'use client'

import { useEffect, useRef } from 'react'

import type { Options } from '@segment/analytics-next'

import { detectPlatform } from './detectPlatform'
import { getAnalytics } from './getAnalytics'

export const PageTrack = ({ pageName }: { pageName: string }) => {
  const didPage = useRef(false)

  useEffect(() => {
    if (didPage.current) return

    const run = () => {
      const a = getAnalytics()
      if (!a) return

      const platform = detectPlatform()

      const options: Options = {
        context: {
          platform: platform,
        },
      }

      a.page(
        pageName,
        {
          title: pageName,
          platform: platform,
        },
        options,
      )
      didPage.current = true
    }

    run()
  }, [pageName])

  return null
}
